import { useSelector } from "react-redux";

import { CompanyContext } from "../../../../components/CompanyList/CompanyContext";
import { sortedCompaniesSelector } from "../../../../selectors/companies";
import { DuoToneSearchIcon } from "../../../assets/DuoToneSearchIcon";
import { FormWrapper } from "./FormWrapper";

export const BackgroundSearchWidget = () => {
	const companies = useSelector(sortedCompaniesSelector);
	const beenVerifiedCompany = companies.find(
		(company) => company.fields.companySlug === "beenverified",
	);

	if (!beenVerifiedCompany) return null;

	return (
		<CompanyContext.Provider value={{ company: beenVerifiedCompany }}>
			<div className="tw:my-6 tw:flex tw:items-center tw:justify-between tw:rounded-lg tw:bg-white tw:p-4 tw:shadow-[0px_4px_16px_0px_rgba(30,25,40,0.06)] tw:max-lg:flex-col tw:max-lg:gap-6">
				<div className="tw:flex tw:items-center tw:gap-4 tw:max-lg:w-full">
					<div className="tw:rounded-full tw:bg-[#FDEEF2] tw:p-4 tw:max-md:p-3">
						<DuoToneSearchIcon
							className="tw:text-[32px] tw:text-[#22293A] tw:max-md:text-[26px]"
							curveColor="#E1255B"
						/>
					</div>
					<div className="tw:max-w-[280px] tw:text-2xl tw:leading-8 tw:font-bold tw:tracking-[-0.48px] tw:text-[#131D2B] tw:max-md:text-xl tw:max-md:leading-[26px] tw:max-md:tracking-[-0.4px]">
						Want to Know About Someone?
					</div>
				</div>
				<FormWrapper />
			</div>
		</CompanyContext.Provider>
	);
};
